import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

const PartnerTemporaryDisableOverlay = ({ onSignOut }) => (
  <Box
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="partner-access-disabled-title"
    aria-describedby="partner-access-disabled-copy"
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      bgcolor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgba(18, 17, 16, 0.72)' : 'rgba(255, 255, 255, 0.72)',
      backdropFilter: 'blur(24px)',
      WebkitBackdropFilter: 'blur(24px)',
    }}
  >
    <Box
      sx={{
        width: '100%',
        maxWidth: 440,
        bgcolor: 'background.paper',
        borderRadius: '16px',
        p: { xs: 3, sm: 4 },
        textAlign: 'center',
        border: (theme) => `1px solid ${theme.palette.divider}`,
        boxShadow: (theme) => theme.portal?.cardShadow ?? theme.shadows[8],
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: 'error.light',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <BlockIcon sx={{ fontSize: 32, color: 'error.main' }} />
      </Box>
      <Typography
        id="partner-access-disabled-title"
        sx={{ fontWeight: 800, fontSize: '1.25rem', color: 'text.primary', mb: 1 }}
      >
        Access temporarily disabled
      </Typography>
      <Typography
        id="partner-access-disabled-copy"
        sx={{ fontSize: '0.9375rem', color: 'text.secondary', lineHeight: 1.6, mb: 3 }}
      >
        Your organization&apos;s partner portal access has been temporarily disabled. You can sign
        out now. Access will return here as soon as it is restored. For any queries, contact{' '}
        <Box
          component="a"
          href="mailto:ceo@sure-space.com"
          sx={{ color: 'primary.main', fontWeight: 700, textDecoration: 'none' }}
        >
          ceo@sure-space.com
        </Box>
        .
      </Typography>
      {onSignOut ? (
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={onSignOut}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '12px',
            px: 3,
            py: 1.25,
          }}
        >
          Sign out
        </Button>
      ) : null}
    </Box>
  </Box>
);

export default PartnerTemporaryDisableOverlay;
